import {Table } from 'antd'
import React, { useEffect, useState } from 'react'
import CostEdit from './CostEdit';
import Copy from '../../cpn/Copy';
import ReportCheck from '../report/ReportCheck';
import classes from './cost.module.css';
import StateTag from '../../cpn/StateTag';
function CostListPendding(props) {
    const [list,setList] = useState([]);   
    useEffect(() => {
        if (props.list) {
            let arr = props.list.filter((item) => item.ddzc_state === '1' && item.ddzc_uid === props.yh_id);            
            arr.sort((a, b) => new Date(b.ddzc_ctime) - new Date(a.ddzc_ctime));
             // Ensure each item has a unique key property
             arr = arr.map((item) => ({
                ...item,
                key: item.key || item.ddsr_id
            }));
            setList(arr);
        }
    }, [props.list, props.yh_id])
    
    const columns = [    
        {
            title: '付款客户',
            dataIndex: 'ddzc_kh_name',
            width: '12%',
            key: 'ddzc_kh_name',         
            render: (text, record) => <CostEdit 
                                        ddzc_id={record.key} 
                                        yh_id={props.yh_id}
                                        yh_name={props.yh_name}
                                        ddzc_bzd_id={record.ddzc_bzd_id}
                                        ddzc_price={record.ddzc_price}
                                        ddzc_content={record.ddzc_content}
                                        ddzc_date={record.ddzc_date}
                                        ddzc_date_end={record.ddzc_date_end}
                                        ddzc_bzd_name={record.ddzc_bzd_name}
                                        ddzc_bzd_danhao={record.ddzc_bzd_danhao}
                                        ddzc_type_id={record.ddzc_type_id}
                                        ddzc_type_name={record.ddzc_type_name}
                                        ddzc_kh_id={record.ddzc_kh_id}
                                        ddzc_kh_name={record.ddzc_kh_name}
                                        qy_id={props.qy_id}
                                        qy_name={props.qy_name}
                                        ddzc_num={record.ddzc_num}
                                        ddzc_amount={record.ddzc_amount}
                                        ddzc_state={record.ddzc_state}
                                        ddzc_bm_id={record.ddzc_bm_id}
                                        ddzc_bm_name={record.ddzc_bm_name}
                                        ddzc_khyhzh_id={record.ddzc_khyhzh_id}
                                        ddzc_khyhzh_name={record.ddzc_khyhzh_name}
                                        ddzc_image_name={record.ddzc_image_name}
                                        ddzc_image_file={record.ddzc_image_file}
                                        ddzc_ctime={record.ddzc_ctime}
                                    />
        },
        {
            title: '付款金额',
            dataIndex: 'ddzc_amount',
            width: '10%',
            key: 'ddzc_amount',   
            render: (text, record) => <span style={{color:'green'}}>￥{Number(text).toLocaleString('zh-CN', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            })}</span>
        },
        {
            title: '备注',
            dataIndex: 'ddzc_content',
            key:'ddzc_content',
            render:(text) => <Copy title={text}/>
        },   
        {
            title: '团队名称',
            width: '10%', 
            dataIndex:"ddzc_bzd_danhao",
            key:'ddzc_bzd_danhao',
            render:(text,record) => {
                return <ReportCheck  dsbzd_name={record.ddzc_bzd_name} dsbzd_id={record.ddzc_bzd_id} dsbzd_danhao={record.ddzc_bzd_danhao} yh_id={props.yh_id}  yh_name={props.yh_name} qy_id={props.qy_id} qy_name={props.qy_name}/>
            }
        },      
        {
            title: '状态',
            dataIndex: 'ddzc_state',
            width: '5%',
            key: 'ddzc_state',            
            render:(text) => <StateTag state={text} />
        },
        {
            title: '编号',
            dataIndex: 'key',
            width: '5%',
            key: 'key',                        
        },
        
    ]
    return (
        <>                            
            {/* <Flex style={{ marginBottom: "10px" }} justify='space-between' align='center'>
                <Form 
                    name='income' 
                    layout='inline' 
                    form={form}
                    onFinish={(values) => {
                        console.log(values,'values');
                        setQuery(prev => ({
                            ...prev, 
                            ddzc_content: values.ddzc_content ? values.ddzc_content : '', 
                            ddzc_kh_id: values.ddzc_kh_id ? values.ddzc_kh_id : '',
                            ddzc_bzd_danhao: values.ddzc_bzd_danhao ? values.ddzc_bzd_danhao : '',
                        }))
                    }}
                    initialValues={{
                        ddzc_content:'',
                        ddzc_kh_id:'',
                        ddzc_bzd_danhao:'',
                    }}
                >
                    <Form.Item name='ddzc_kh_id'>
                        <ClientSelect
                            wrapperCol={null}
                            qy_id={props.qy_id}
                            qy_name={props.qy_name}
                            yh_id={props.yh_id}
                            yh_name={props.yh_name}
                            style={{width:'150px'}}
                            onChange={() => {}}
                        />
                    </Form.Item>
                    <Form.Item name='ddzc_bzd_danhao'>
                        <Input 
                            placeholder='团队编号' 
                           
                        />
                    </Form.Item>                    
                    <Form.Item name='ddzc_content'>
                        <Input 
                            placeholder='备注关键字' 
                           
                        />
                    </Form.Item>                    
                    <Form.Item>
                        <Space align='center' size='middle'>
                            <Icon type='search' onClick={() => {form.submit()}}/>
                            <Icon 
                                type='reset' 
                                onClick={() => {
                                    form.resetFields()
                                    setQuery({
                                        ddzc_content:''
                                    })
                                }}
                            />                          
                        </Space>
                    </Form.Item>
                </Form>
            </Flex> */}
            <Table 
                className={classes.greenHeader}
                dataSource={list}
                columns={columns}
                pagination={false}
                size='small'
                bordered
                rowKey="key"
                summary={pageData => {
                    const total = pageData.reduce((sum, row) => sum + Number(row.ddzc_amount || 0), 0);
                    return (
                        <Table.Summary.Row>
                            <Table.Summary.Cell index={0}></Table.Summary.Cell>
                            <Table.Summary.Cell index={1} colSpan={1}>
                                <span style={{color:'green'}}>合计：￥{Number(total).toLocaleString('zh-CN', {
                                                                minimumFractionDigits: 2,
                                                                maximumFractionDigits: 2
                                                            })}</span>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell index={2} colSpan={columns.length - 2} />
                        </Table.Summary.Row>
                    );
                }}
                locale={{
                    emptyText: '暂无付款数据' // This will display text when the table is empty
                }}
            />
        </>
    )
}

export default CostListPendding